var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoTriangleOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8331 7.49996C10.8331 7.9602 10.46 8.33329 9.99977 8.33329C9.53953 8.33329 9.16643 7.9602 9.16643 7.49996C9.16643 7.03972 9.53953 6.66663 9.99977 6.66663C10.46 6.66663 10.8331 7.03972 10.8331 7.49996Z",
    fill: "#FD9567"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99977 9.79163C10.3449 9.79163 10.6248 10.0714 10.6248 10.4166V14.5833C10.6248 14.9285 10.3449 15.2083 9.99977 15.2083C9.65459 15.2083 9.37477 14.9285 9.37477 14.5833V10.4166C9.37477 10.0714 9.65459 9.79163 9.99977 9.79163Z",
    fill: "#FD9567"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8917 3.32716C10.9817 1.99577 9.01775 1.99576 8.10778 3.32715L7.74784 3.85377C5.49281 7.15312 3.55534 10.6586 1.9614 14.3234L1.88622 14.4962C1.32451 15.7877 2.17314 17.2541 3.57276 17.4105C7.84412 17.8879 12.1554 17.8879 16.4267 17.4105C17.8264 17.2541 18.675 15.7877 18.1133 14.4962L18.0381 14.3234C16.4442 10.6586 14.5067 7.15312 12.2517 3.85378L11.8917 3.32716ZM9.13976 4.03249C9.55339 3.42732 10.4461 3.42732 10.8597 4.0325L11.2197 4.55912C13.4302 7.7933 15.3294 11.2296 16.8918 14.8219L16.967 14.9948C17.1932 15.5148 16.8515 16.1053 16.2879 16.1683C12.1088 16.6353 7.89069 16.6353 3.7116 16.1683C3.14802 16.1053 2.80631 15.5148 3.03249 14.9948L3.10767 14.8219C4.67013 11.2296 6.56933 7.7933 8.77983 4.55912L9.13976 4.03249Z",
    fill: "#FD9567"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoTriangleOrange);
export default __webpack_public_path__ + "static/media/Info-triangle-orange.429be55c2a6d4d2795edcf44f5d3fcda.svg";
export { ForwardRef as ReactComponent };